import * as PIXI from "pixi.js";

import Rect from "./_rect";

export default class Tengoku {
    constructor(app, tex) {
        this.isSp = true;

        this.app = app;
        this.tex = tex;
        this.graphics = null;
        this.container = null;
        this.drawList = [];

        this._setBp();
        this._init();
    }

    _init() {
        this._drawContent();
        this._drawGraphics();
    }

    _setBp() {
        const mediaQuery = window.matchMedia("(max-width: 1025px)");
        // イベントリスナーを登録

        mediaQuery.addListener((e) => {
            this._handleTabletChange(e);
        });

        this._handleTabletChange(mediaQuery);
    }

    _handleTabletChange(e) {
        if (e.matches) {
            this.isSp = true;
            //console.log(this.isSp);
        } else {
            this.isSp = false;
            //console.log(this.isSp);
        }
    }

    update() {
        this.graphics.clear();

        this.drawList.forEach((rect) => {
            rect.update();
        });
    }

    _drawContent() {
        this.isTween = false;

        this.container = new PIXI.Container();

        // 背景テクスチャ
        const bg = PIXI.Sprite.from(this.tex.tengoku_bg);
        bg.anchor.set(0.5);
        bg.x = window.innerWidth / 2;
        bg.y = window.innerHeight / 2;
        bg.scale.x = this.isSp ? 1 : 1.5;
        bg.scale.y = this.isSp ? 1 : 1.5;

        // キャッチ テキスト
        /* const txt = PIXI.Sprite.from(this.tex.tengoku_txt);
        txt.anchor.set(0.5);
        txt.x = this.isSp ? window.innerWidth / 2 : window.innerWidth / 2;
        txt.y = this.isSp ? window.innerHeight / 2 : window.innerHeight / 2;
        txt.width = this.isSp ? 53 : 107;
        txt.height = this.isSp ? 330 : 660;  */

        this.container.addChild(bg);
        /* this.container.addChild(txt); */
        this.app.stage.addChild(this.container);
    }

    _drawGraphics() {
        const row = 80;

        this.graphics = new PIXI.Graphics();
        this.graphics.beginFill(0x000000);

        for (let i = 0; i < row; i++) {
            const yy = (window.innerHeight / row) * i + 10;

            const xx = Math.random() * 100;
            const ww = Math.max(window.innerWidth / 7, (Math.random() * window.innerWidth) / 2);
            this.drawList.push(new Rect(this.graphics, xx, yy - Math.random() * 20, ww));

            const xx2 = xx + ww + Math.max(20, Math.random() * 100);
            const ww2 = Math.max(window.innerWidth / 7, (Math.random() * window.innerWidth) / 2);
            this.drawList.push(new Rect(this.graphics, xx2, yy - Math.random() * 20, ww2));

            if (xx2 + ww2 < window.innerWidth * 0.9) {
                const xx3 = xx2 + ww2 + Math.max(20, Math.random() * 100);
                const ww3 = Math.max(window.innerWidth / 3, (Math.random() * window.innerWidth) / 2);
                this.drawList.push(new Rect(this.graphics, xx3, yy - Math.random() * 20, ww3));
            }
        }

        this.graphics.blendMode = PIXI.BLEND_MODES.DST_OUT;
        this.app.stage.addChild(this.graphics);
    }

    onDestroy() {
        this.graphics.blendMode = "";
    }
}
